import React from "react";
import styles from "../../ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails.module.scss";
import { Card, Box, Typography, Chip, Container } from "@mui/material";
import FormGenerator from "../../../components/FormBuilder/FormBuilder";
import useAddPayment from "./useFundAddPayment"
import { FundAddPaymentForm } from "../../../types/formTypes"


const FundAddPayment = () => {
    const { fundsFormFields, handleOnSubmit, fundDetail } = useAddPayment()
    
    return (<Container className={styles.container}>
        <Box>
            <Box className={styles.header}>
                <Typography variant="h5" className={styles.title}>
                    Add Payment Details
                </Typography>
                <Box className={styles.navigationButtons}>
                    <Typography variant="h6">
                        Student Name
                    </Typography>
                    {fundDetail?.name && <Chip label={fundDetail?.name} color="info" sx={{ fontSize: 16 }} />}
                    <Typography variant="h6">
                        Scholarship ID
                    </Typography>
                    {fundDetail?.scholarship_id && <Chip label={fundDetail?.scholarship_id} color="success" sx={{ fontSize: 16 }} />}
                </Box>
            </Box>
            <FormGenerator<FundAddPaymentForm> fields={fundsFormFields} onSubmit={handleOnSubmit} direction="row" />
        </Box>
    </Container>)
}

export default FundAddPayment